import fileUploadImg from 'static/images/file-upload.svg';
import crossImg from 'static/images/close.svg';

import React, { useCallback, useState } from 'react';
import { useDropzone } from 'react-dropzone';
import styled from 'styled-components';
import PropTypes from 'prop-types';

const MainContainer = styled.div`
    overflow: hidden;
    width: 100%;
`;

// Styled components
const DropzoneContainer = styled.div`
    border: 1px solid #c3c1bf;
    border-radius: 10px;
    height: ${props => (props.layout === 'vertical' ? '250px' : '100px')};
    width: 100%;
    padding: 20px;
    cursor: pointer;
    background: ${props => (props.layout === 'vertical' ? '#eff2f9' : '100px')};
`;

const FileList = styled.div`
    display: flex;
    flex-wrap: wrap;
`;

const StyledFile = styled.div`
    padding: 5px;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 10px;
    border: 1px solid #efefef;
    border-radius: 8px;
    margin: 15px 15px 0 0;
    position: relative;
`;

const StyledComponent = styled.div`
    display: flex;
    align-content: center;
    justify-content: flex-start;
    align-items: center;
    flex-direction: ${props =>
        props.layout === 'vertical' ? 'column' : 'row'};
`;
const StyledImg = styled.img`
    margin-right: 20px;
`;

const StyledDiv = styled.div`
    display: ${props => (props.layout === 'vertical' ? 'flex' : '')};
    flex-direction: ${props => (props.layout === 'vertical' ? 'column' : '')};
    align-items: ${props => (props.layout === 'vertical' ? 'center' : '')};
    align-content: ${props => (props.layout === 'vertical' ? 'center' : '')};
    justify-content: ${props => (props.layout === 'vertical' ? 'center' : '')};
`;

const StyledTitle = styled.p`
    font-family: 'lato-regular';
    font-size: 18px;
    font-weight: 600;
    padding-top: ${props => (props.layout === 'vertical' ? '10px' : '')};
`;
const StyledParagraph = styled.p`
    font-size: 12px;
    font-weight: 400;
    line-height: 22px;
`;

const StyledSpan = styled.span`
    color: #ff7744;
`;

const StyledSeprator = styled.div`
    margin: ${props => (props.layout === 'vertical' ? '20px 0' : '0 40px')};
    font-size: 12px;
    line-height: 22px;
`;
const StyledButton = styled.div`
    background-color: #fff;
    z-index: 10;
    border: 1px solid #ff7744;
    color: #ff7744;
    border-radius: 4px;
    font-family: 'lato-regular';
    font-size: 14px;
    font-weight: 500;
    padding: 12px 20px;
    margin: 0 auto;
`;

const ErrorWrapper = styled.span`
    color: #f00;
    display: block;
    font-size: 12px;
    margin: 8px 0;
    /* text-transform: capitalize; */
`;

const FileNameSpan = styled.span`
    margin-right: 5px;
`;

const CloseIcon = styled.img`
    top: -10px;
    right: -10px;
    position: absolute;
    cursor: pointer;
`;

// Redux-Form field component
const MultiUpload = ({
    input: { value, onChange },
    onFileListChange,
    layout,
    subtitle,
    accept,
    fileList,
    maxSize,
    meta,
}) => {
    const [isDropFailed, setIsDropFailed] = useState(false);

    const removeFile = file => () => {
        const newFiles = [...fileList];
        newFiles.splice(newFiles.indexOf(file), 1);

        onChange(newFiles);
        onFileListChange(newFiles);
    };

    const onDrop = useCallback(
        (acceptedFiles, fileRejections) => {
            if (fileRejections && fileRejections.length > 0) {
                setIsDropFailed(true);
            } else {
                setIsDropFailed(false);
            }
            const newFiles = [...fileList, ...acceptedFiles];
            onChange(newFiles);
            onFileListChange(newFiles);
        },
        [onChange, onFileListChange]
    );

    const { getRootProps, getInputProps } = useDropzone({
        onDrop,
        accept,
        maxSize,
    });

    return (
        <MainContainer layout={layout}>
            <DropzoneContainer {...getRootProps()} layout={layout}>
                <StyledComponent layout={layout}>
                    <StyledImg
                        src={fileUploadImg}
                        alt="fileUploadImg"
                        layout={layout}
                    />
                    <StyledDiv layout={layout}>
                        <StyledTitle layout={layout}>
                            Drop Files Here to Upload{' '}
                            {value && value.length > 0 ? (
                                <StyledSpan layout={layout}>
                                    ({value.length} files selected)
                                </StyledSpan>
                            ) : (
                                ''
                            )}
                        </StyledTitle>
                        <StyledParagraph layout={layout}>
                            {!isDropFailed ? (
                                subtitle
                            ) : (
                                <ErrorWrapper>{subtitle}</ErrorWrapper>
                            )}
                        </StyledParagraph>
                    </StyledDiv>
                    <StyledSeprator layout={layout}>OR</StyledSeprator>
                    <StyledButton layout={layout}>Browse File</StyledButton>
                    <input {...getInputProps()} />
                </StyledComponent>
            </DropzoneContainer>
            {value && (
                <FileList layout={layout}>
                    {value.map((file, index) => (
                        <StyledFile key={index}>
                            <FileNameSpan>{file.name}</FileNameSpan>
                            <CloseIcon
                                src={crossImg}
                                alt="cross"
                                onClick={removeFile(file)}
                            ></CloseIcon>
                        </StyledFile>
                    ))}
                </FileList>
            )}
            {meta && meta.error && meta.touched ? (
                <ErrorWrapper>{meta.error}</ErrorWrapper>
            ) : (
                <></>
            )}
        </MainContainer>
    );
};

export default MultiUpload;

MultiUpload.propTypes = {
    customClass: PropTypes.string,
    handleChange: PropTypes.func,
    labelField: PropTypes.string,
    options: PropTypes.array,
    valueField: PropTypes.string,
    input: PropTypes.object,
    meta: PropTypes.object,
    wrapperClass: PropTypes.string,
    layout: PropTypes.string,
    subtitle: PropTypes.string,
    onFileListChange: PropTypes.func,
    fileList: PropTypes.array,
};
